import { create } from 'zustand'
import type { ApplicationParameter } from '../types/api.generated'

export type { ApplicationParameter } from '../types/api.generated'

interface User {
  id: string | number
  walletAddress?: string
  address?: string
  username: string | null
  email: string | null
  avatar?: string | null
  pointsBalance: number
  role: string
  createdAt?: string
  updatedAt?: string
}

interface AuthState {
  user: User | null
  applicationParameters: ApplicationParameter[]
  setUser: (user: User | null) => void
  setApplicationParameters: (parameters: ApplicationParameter[]) => void
  getApplicationParameter: (code: string) => ApplicationParameter | undefined
  isAdmin: () => boolean
  isLoggedIn: () => boolean
  logout: () => void
  debitPoints: (amount: number) => void
  updatePoints: (amount: number) => void
}

// Store Zustand
export const useAuthStore = create<AuthState>((set, get) => ({
  user: (() => {
    const stored = sessionStorage.getItem('authUser')
    return stored ? JSON.parse(stored) : null
  })(),
  applicationParameters: (() => {
    const stored = sessionStorage.getItem('applicationParameters')
    return stored ? JSON.parse(stored) : []
  })(),

  setUser: (user) => {
    if (user) sessionStorage.setItem('authUser', JSON.stringify(user))
    else sessionStorage.removeItem('authUser')
    set({ user })
  },

  setApplicationParameters: (parameters) => {
    if (parameters.length) {
      sessionStorage.setItem('applicationParameters', JSON.stringify(parameters))
    } else {
      sessionStorage.removeItem('applicationParameters')
    }
    set({ applicationParameters: parameters })
  },

  getApplicationParameter: (code) =>
    get().applicationParameters.find((parameter) => parameter.code === code),

  isAdmin: () => get().user?.role === 'admin',

  isLoggedIn: () => !!get().user,

  logout: () => {
    sessionStorage.removeItem('authUser')
    sessionStorage.removeItem('tokenUser')
    sessionStorage.removeItem('applicationParameters')
    set({ user: null, applicationParameters: [] })
  },

  debitPoints: (amount: number) => {
    set((state) => {
      if (!state.user) return state

      const updatedUser: User = {
        ...state.user,
        pointsBalance: state.user.pointsBalance - amount,
      }

      sessionStorage.setItem('authUser', JSON.stringify(updatedUser))

      return { user: updatedUser }
    })
  },
  updatePoints: (amount: number) => {
    set((state) => {
      if (!state.user) return state

      const updatedUser: User = {
        ...state.user,
        pointsBalance: state.user.pointsBalance + amount,
      }

      sessionStorage.setItem('authUser', JSON.stringify(updatedUser))

      return { user: updatedUser }
    })
  },


}))
